import {Component, OnInit} from '@angular/core';
import {Model} from '../../app.model';
import {SubscriptionService} from '../subscription.service';
import {Subscription} from '../subscription.model';
import {filterText} from '@myshared/utils';
import {ActivatedRoute, Router} from '@angular/router';
import {AutorunComponent} from '@myshared/autorun.component';
import {runInAction} from 'mobx';
import {action, observable} from '@myshared/mobx-connector';
import {LocalizedDatePipe} from '@myshared/localized-date.pipe';
import {IDropdownItem} from "@myshared/pascom-dropdown-multiselect/pascom-dropdown";
import {I18NextService} from "angular-i18next";

@Component({
    selector: 'subscription-list',
    templateUrl: './subscription-list.component.html',
    providers: [LocalizedDatePipe],
    styleUrls: [],
    standalone: false
})
export class SubscriptionListComponent extends AutorunComponent implements OnInit {

  public subscriptions: Subscription[];
  public isPartner: boolean;
  public filterMy: boolean;
  public isAdmin: boolean;
  public numberOfExpiredSubscriptions: number;
  public nfr: Subscription[];
  public isSubscriptionsInitialized: boolean;
  public hasNfrOne: boolean;
  public isCspOne: boolean;
  public dropdownFilterOptions: IDropdownItem[] = []

  private applianceStatusLoaded = false;

  @observable private filter$: string;
  @observable private showExpired$: boolean;
  @observable private showFilter$: string[];

  private cspFilterInitialized = false;

  constructor(
    private m: Model,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private datePipe: LocalizedDatePipe,
    private route: ActivatedRoute,
    private i18next: I18NextService
  ) { super(); }

  ngOnInit() {
    runInAction(() => {
      this.showExpired$ = false;
      this.showFilter$ = [];
      this.filter$ = '';
    });
    this.dropdownFilterOptions = []

    this.autorun(() => {
      this.isPartner = this.m.account.currentUser.companyIsPartner;
      this.isCspOne = this.m.account.currentUser.companyIsPC20Csp;
      this.hasNfrOne = this.m.subscription.hasNfrOne;
      this.isAdmin = this.m.account.isMypascomAdmin;
      if (!this.isPartner && (this.router.url.endsWith('customer') || this.router.url.endsWith('subscriptions'))) {
        this.router.navigate(['/subscriptions/my']);
      } else if (this.isPartner && this.router.url.endsWith('subscriptions')) {
        this.router.navigate(['/subscriptions/customer']);
      } else {
        // enforce license fetch from the backend
        // only when the redirection to /my or /customer already happened
        // because ngOnInit is called multiple times during redirections
        this.subscriptionService.refresh(true);
      }
    });

    this.autorun(() => {
      this.isSubscriptionsInitialized = this.m.subscription.initialized;
      this.filterMy = this.router.url.endsWith('my');

      if (this.isSubscriptionsInitialized && this.subscriptions && this.subscriptions.length > 0) {
        for (const sub of this.subscriptions) {
          for (const trunk of sub.trunks) {
            const code = this.dropdownFilterOptions.find(option => option.code === trunk);
            if (!code) {
              const trunkDisplayName = this.i18next.t('trunk_filter', ({ name: trunk })) as string;
              this.dropdownFilterOptions.push({
                name: trunkDisplayName,
                code: trunk
              });
            }
          }
        }
      }

      this.numberOfExpiredSubscriptions = this.m.subscription.subscriptions.filter(l => this.filterMy ? l.is_my : !l.is_my).filter(s => !s.isValid).length;
      if (this.m.subscription.subscriptions.length > 0 && !this.applianceStatusLoaded) {
        this.subscriptionService.refreshSubscriptionsBootstate();
        this.applianceStatusLoaded = true;
      }

      const subscriptions = this.m.subscription.subscriptions
        .filter(l => this.filterMy ? l.is_my : !l.is_my)
        .filter(s => this.showExpired$ ? !s.isValid : s.isValid)
        .filter(s => {
          if (this.showFilter$.length === 0) return true;
          return !!s.trunks.find(trunk => this.showFilter$.includes(trunk));
      });
      this.subscriptions = filterText(subscriptions, this.filter$)

      if (!this.isPartner && this.m.subscription.initialized && this.m.subscription.subscriptions.length === 0 && this.m.account.isMypascomAdmin) {
        this.router.navigate(['/subscriptions', 'select-product']);
      }
    });
  }

  public onMultiFilterChanged(items: IDropdownItem[]) {
    const filter: string[] = [];
    items.map(r => { filter.push(r.code) });

    runInAction(() => {
      this.showFilter$ = filter;
    })
  }

  @action
  public showExpired(value: boolean) {
    this.showExpired$ = value;
  }

  @action
  doFilter(filter: string) {
    this.filter$ = filter;
  }

  doUpgradeExpiredOneTrial(applianceId: string) {
    this.router.navigate(['/do', 'upgrade', applianceId, ''], {
      queryParams: {fromwf: this.route.snapshot.paramMap.get('b64')}
    });
  }

  public get headline() {
    if (this.filterMy) {
      return 'my_subscription_headline'
    }

    return 'customer_subscription_headline';
  }

  public get partnerCanAddNfrOne() {
    return this.subscriptionService.partnerCanCreateNfrOne;
  }
}
